/** Datas civis locais: sem conversão para UTC que deslocaria o dia no Brasil. */
export function calendarIso(date: Date): string {
  return `${String(date.getFullYear()).padStart(4, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function parseCalendarDate(value: string): string {
  const normalized = value.trim();
  const br = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(normalized);
  const iso = br ? `${br[3]}-${br[2]}-${br[1]}` : normalized;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return '';
  const date = new Date(`${iso}T12:00:00`);
  return Number.isNaN(date.getTime()) || date.getFullYear() < 100 || calendarIso(date) !== iso ? '' : iso;
}

export function displayCalendarDate(value: string): string {
  return parseCalendarDate(value) ? value.split('-').reverse().join('/') : '';
}

export function calendarDateAllowed(iso: string, min?: string, max?: string): boolean {
  return Boolean(parseCalendarDate(iso)) && (!min || iso >= min) && (!max || iso <= max);
}
